export const DATE_OPTIONS = {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
}
